/**
 * Tailwind descendant selectors that strip the inner `Input.vue` and
 * `Textarea.vue` of their own border, padding, and focus ring so they sit
 * flush inside a parent container that owns the chrome (the inset variant
 * or the field stack). Both primitives carry `data-slot="input"` /
 * `data-slot="textarea"` precisely as override hooks for this pattern.
 *
 * Kept as a shared constant so the inset variant and `FormFieldStack`
 * apply the exact same reset — drift between the two would create
 * subtle visual mismatches in mixed forms.
 */
export const insetInputResetClasses = [
  '[&_input[data-slot=input]]:border-0',
  '[&_input[data-slot=input]]:bg-transparent',
  '[&_input[data-slot=input]]:rounded-none',
  '[&_input[data-slot=input]]:px-0',
  '[&_input[data-slot=input]]:h-auto',
  '[&_input[data-slot=input]]:py-0',
  '[&_input[data-slot=input]]:shadow-none',
  '[&_input[data-slot=input]]:font-medium',
  '[&_input[data-slot=input]]:text-foreground',
  '[&_input[data-slot=input]]:focus-visible:ring-0',
  '[&_input[data-slot=input]]:focus-visible:border-0',
  '[&_input[data-slot=input]]:focus-visible:ring-offset-0',
  '[&_textarea[data-slot=textarea]]:border-0',
  '[&_textarea[data-slot=textarea]]:bg-transparent',
  '[&_textarea[data-slot=textarea]]:rounded-none',
  '[&_textarea[data-slot=textarea]]:px-0',
  '[&_textarea[data-slot=textarea]]:py-0',
  '[&_textarea[data-slot=textarea]]:shadow-none',
  '[&_textarea[data-slot=textarea]]:font-medium',
  '[&_textarea[data-slot=textarea]]:text-foreground',
  '[&_textarea[data-slot=textarea]]:focus-visible:ring-0',
  '[&_textarea[data-slot=textarea]]:focus-visible:border-0',
  '[&_textarea[data-slot=textarea]]:focus-visible:ring-offset-0',
  '[&_[data-slot=combobox-anchor]]:border-0',
  '[&_[data-slot=combobox-anchor]]:rounded-none',
  '[&_[data-slot=combobox-anchor]]:shadow-none',
  '[&_[data-slot=combobox-anchor]]:h-auto',
  '[&_[data-slot=combobox-anchor]]:px-0',
  '[&_[data-slot=combobox-anchor]]:focus-within:ring-0',
  '[&_[data-slot=combobox-anchor]]:focus-within:border-0',
  '[&_[data-slot=combobox-input]]:h-auto',
  '[&_[data-slot=combobox-input]]:px-0',
  '[&_[data-slot=combobox-input]]:py-0',
  '[&_[data-slot=select-trigger]]:border-0',
  '[&_[data-slot=select-trigger]]:rounded-none',
  '[&_[data-slot=select-trigger]]:shadow-none',
  '[&_[data-slot=select-trigger]]:h-auto',
  '[&_[data-slot=select-trigger]]:px-0',
  '[&_[data-slot=select-trigger]]:focus-visible:ring-0',
  '[&_[data-slot=select-trigger]]:focus-visible:border-0'
]
